import { UserRole, PermissionAction, PermissionsAlias } from './roles'
import { RouteNames, type RouteName } from './route-names'
import type { PermissionKey } from './permissions'

/**
 * Agent 系统角色权限配置
 * Key: 角色ID
 * Value: 该角色拥有的权限列表，或 'has_all_permission' 表示拥有所有权限
 */
export const AgentRolePermissionConfig: Record<UserRole, PermissionKey[] | PermissionsAlias> = {
  // Agent 超级管理员 - 拥有所有 Agent 路由的所有权限
  [UserRole.SUPER_ADMIN]: PermissionsAlias.hasAllPermission,
  // Agent 管理员 - 拥有所有 Agent 路由的所有权限
  [UserRole.ROLE_AGENT_ADMIN]: PermissionsAlias.hasAllPermission,

  // Agent 用户 - 仅可查看，部分编辑权限
  [UserRole.ROLE_AGENT_USER]: [
    // 猎头职位列表 - 可查看和编辑
    `${RouteNames.AgentJobList}:${PermissionAction.SHOW}`,
    `${RouteNames.AgentJobList}:${PermissionAction.EDIT}`,
    // 职位详情 - 仅查看
    `${RouteNames.JobDetail}:${PermissionAction.SHOW}`,
    `${RouteNames.JobDetail}:${PermissionAction.EDIT}`,

    // 企业管理
    `${RouteNames.BusinessManage}:${PermissionAction.SHOW}`,

    // 选考中候选人 
    `${RouteNames.CandidateSelecting}:${PermissionAction.SHOW}`,
    `${RouteNames.CandidateSelecting}:${PermissionAction.EDIT}`,
    `${RouteNames.CandidateSelecting}:${PermissionAction.DOWNLOAD}`,
    `${RouteNames.CandidateSelectingDetail}:${PermissionAction.SHOW}`,
    `${RouteNames.CandidateSelectingDetail}:${PermissionAction.EDIT}`,
    `${RouteNames.CandidateSelectingDetail}:${PermissionAction.DOWNLOAD}`,

    // 注册候选人 - 查看所有人添加的注册候选人，可管理，可下载
    `${RouteNames.CandidateRegistered}:${PermissionAction.SHOW}`,
    `${RouteNames.CandidateRegistered}:${PermissionAction.EDIT}`,
    `${RouteNames.CandidateRegistered}:${PermissionAction.DOWNLOAD}`,
    `${RouteNames.CandidateDetail}:${PermissionAction.SHOW}`,
    `${RouteNames.CandidateDetail}:${PermissionAction.EDIT}`,
    `${RouteNames.CandidateDetail}:${PermissionAction.DOWNLOAD}`,
    `${RouteNames.CandidateEdit}:${PermissionAction.SHOW}`,
    `${RouteNames.CandidateEdit}:${PermissionAction.EDIT}`,

    // 账号管理
    `${RouteNames.Account}:${PermissionAction.SHOW}`,
    // 选考设置 - 仅查看选考流程和申请渠道来源
    `${RouteNames.InterviewSettingAgent}:${PermissionAction.SHOW}`,
    `${RouteNames.InterviewChannel}:${PermissionAction.SHOW}`,

    // 通知中心
    `${RouteNames.Notify}:${PermissionAction.SHOW}`,
    `${RouteNames.NotifySettings}:${PermissionAction.SHOW}`,
    // 数据概览
    `${RouteNames.DataOverview}:${PermissionAction.SHOW}`,
    `${RouteNames.DataOverview}:${PermissionAction.DOWNLOAD}`,
    `${RouteNames.MyBoard}:${PermissionAction.SHOW}`,
    `${RouteNames.MyBoard}:${PermissionAction.DOWNLOAD}`,

    // 沟通 - 查看聊天页面
    `${RouteNames.Chat}:${PermissionAction.SHOW}`,
  ],
  [UserRole.ROLE_BUSINESS_OPERATION]: [
    // 猎头职位列表 - 可查看和编辑
    `${RouteNames.AgentJobList}:${PermissionAction.SHOW}`,
    `${RouteNames.AgentJobList}:${PermissionAction.EDIT}`,
    // 职位详情 - 仅查看
    `${RouteNames.JobDetail}:${PermissionAction.SHOW}`,
  ],

  // 以下是 Business 系统角色，在 Agent 系统中无权限（返回空数组）
  // [UserRole.SUPER_ADMIN]: PermissionsAlias.hasAllPermission,
  [UserRole.RECRUITMENT_MANAGER]: [],
  [UserRole.RECRUITMENT_SPECIALIST]: [],
  [UserRole.INTERVIEWER]: [],
}
